"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateModel = void 0;
const formik_1 = require("formik");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const config_1 = require("../../config");
const Loading_1 = require("../../components/Loading/Loading");
const AuthLayout_1 = require("../../components/AuthLayout/AuthLayout");
const Button_1 = require("../../components/Button/Button");
const requests_1 = require("../../requests");
const CONTEXT = 'validateModel';
exports.validateModel = (fields, FormComponent) => (WrapperElement) => (props) => {
    const { authenticatedUser } = props;
    const [isLoading, setIsLoading] = react_1.useState(true);
    const [isValid, setIsValid] = react_1.useState(false);
    const [message, setMessage] = react_1.useState('');
    const { t } = react_i18next_1.useTranslation('validateModel');
    const validateUserModel = (userModel) => {
        let valid = true;
        fields.forEach((field) => {
            if (!userModel[field])
                valid = false;
        });
        return valid;
    };
    react_1.useEffect(() => {
        setIsValid(validateUserModel(authenticatedUser));
        setIsLoading(false);
    }, [authenticatedUser]);
    const onSubmit = (body) => {
        return requests_1.patchUserRequest(authenticatedUser.id, body)
            .then(() => window.location.reload())
            .catch((error) => setMessage(config_1.getErrorMessage(error)));
    };
    if (isLoading)
        return react_1.default.createElement(Loading_1.Loading, { centeredVertical: true });
    if (!isValid) {
        return (react_1.default.createElement(AuthLayout_1.AuthLayout, { context: CONTEXT, message: message, links: [] },
            react_1.default.createElement(formik_1.Formik, { onSubmit: onSubmit, initialValues: authenticatedUser }, () => (react_1.default.createElement(formik_1.Form, null,
                react_1.default.createElement(FormComponent, null),
                react_1.default.createElement(Button_1.Button, { type: "submit", id: "submit", className: "float-right" }, t('button')))))));
    }
    return react_1.default.createElement(WrapperElement, Object.assign({}, props));
};
//# sourceMappingURL=validate-model.js.map